// src/config/plotConfigs/pauseDetectionConfig.js
export const pauseDetectionConfig = {
  sections: [
    {
      fields: [
        {
          id: "tran_list",
          label: "Transcripts",
          type: "radio",
          options: [
            { value: "prin_trans", label: "Principal" },
            { value: "all_trans", label: "All" },
            { value: "custom_trans", label: "Custom" },
          ],
          tooltip:
            "Search for pauses only on principal transcripts, all transcripts or a custom list (enter a comma seperated list in the input box).",
          width: 3,
        },
        {
          id: "custom_tran_list",
          label: "Custom transcript list (Optional) ",
          type: "textarea",
          placeholder: "ENST00000312345, ENST00000367890",
          tooltip: "Enter custom transcript list (comma-separated)",
          width: 9,
          rows: 3,
          showIf: (settings) => settings.tran_list === "custom_trans",
        },
        {
          id: "min_fold_change",
          label: "Minimum fold change",
          type: "number",
          placeholder: "10",
          min: 0.1,
          step: 0.1,
          tooltip:
            "A ratio is calculated for each position in the profile by dividing the average count at two adjacent positions by the background density. Any position with a ratio above this value will be returned in the results table",
          width: 12,
        },
        {
          id: "minread",
          label: "Minimum read length",
          type: "number",
          placeholder: "20",
          min: 1,
          max: 1000,
          tooltip:
            "You can specify the footprint read lengths to be considered for the pause prediction(s). The default read length range is 25-35 nt.",
          width: 6,
        },
        {
          id: "maxread",
          label: "Maximum read length",
          type: "number",
          placeholder: "35",
          min: 1,
          max: 1000,
          tooltip:
            "You can specify the footprint read lengths to be considered for the pause prediction(s). The default read length range is 25-35 nt.",
          width: 6,
        },
        {
          id: "reproducible",
          label: "Reproducible pauses only",
          type: "checkbox",
          tooltip: "Only include reproducible pauses",
          width: 3,
        },
        {
          id: "email",
          label: "Email notification",
          type: "checkbox",
          tooltip: "Send email when analysis is complete",
          width: 3,
        },
        // ✅ ADVANCED SETTINGS - These will be shown in modal
        {
          id: "ambig_check",
          label: "Allow ambiguously mapped reads",
          type: "checkbox",
          tooltip: "Include ambiguously mapped reads",
          width: 12,
          advanced: true,
        },
        {
          id: "nuc_output",
          label: "Nucleotide output",
          type: "number",
          placeholder: "15",
          min: 0,
          tooltip:
            "The flanking nucleotide sequences of a predicted pause location are provided in the output. You can specify the length(nt) of up and downstream sequences to be provided in the output file (the default value is 50 nt). The sequence information can be used as input to secondary structure prediction tools which may provide insight into the pause occurrence.",
          width: 6,
          advanced: true,
        },
        {
          id: "min_non_zero",
          label: "Minimum non-zero positions",
          type: "number",
          placeholder: "20",
          min: 0,
          tooltip:
            "The minimum number of positions in a transcript that need to have at least one count. Transcripts that do not meet this threshold will be excluded.",
          width: 6,
          advanced: true,
        },
      ],
    },
  ],
};

export const pauseDetectionDefaults = {
  tran_list: "prin_trans",
  custom_tran_list: "",
  min_fold_change: 10,
  min_non_zero: 20,
  nuc_output: 15,
  minread: 20,
  maxread: 35,
  window_size: 1000,
  min_coverage: 5,
  ambig_check: false,
  reproducible: true,
  email: false,
};

export const pauseDetectionValidation = {
  min_fold_change: { required: true, min: 0.1, label: "Minimum fold change" },
  window_size: { required: true, min: 100, label: "Window size" },
  min_coverage: { required: true, min: 1, label: "Minimum coverage" },
  minread: { required: true, min: 1, max: 1000, label: "Minimum read length" },
  maxread: { required: true, min: 1, max: 1000, label: "Maximum read length" },
  nuc_output: { required: true, min: 0, label: "Nucleotide output" },
  custom: (value, allSettings) => {
    if (allSettings.minread >= allSettings.maxread) {
      return "Min read length must be less than max read length";
    }
    if (
      allSettings.tran_list === "custom_trans" &&
      !allSettings.custom_tran_list.trim()
    ) {
      return "Custom transcript list is required when 'Custom' is selected";
    }
    return null;
  },
};
